import React from 'react';
import { StyledNumbersRowDouble } from './StyledNumbersRowDouble';

const NumbersRowDouble = ({ children }) => {
  return (
    <React.Fragment>
      {
        <StyledNumbersRowDouble>
          {children}
        </StyledNumbersRowDouble>
          
      }
    </React.Fragment>
  );
};


export default NumbersRowDouble;
